const searchToggle = document.querySelectorAll('.js-toggle-search');
const searchClose = document.querySelectorAll('.js-close-search');
const searchInput = document.querySelector('.js-search');

function openSearch(elem) {
    searchInput.classList.add('active');
    searchInput.parentNode.classList.add('active');
}

function toggleSearch(elem) {
    searchInput.classList.toggle('active');
    searchInput.querySelector('.search__input').focus();
}

function closeSearch(elem) {
    searchInput.classList.remove('active');
    searchInput.parentNode.classList.remove('active');
}

for (var i = 0; i < searchToggle.length; i++) {
    searchToggle[i].addEventListener('click', toggleSearch, false);
}

for (var i = 0; i < searchClose.length; i++) {
    searchClose[i].addEventListener('click', closeSearch, false);
}
